import colors from "common/styles/colors";

export const companyAdminsDialogStyles = {
  dialogContainer: {
    zIndex: "9999999 !important" as any,
    padding: "10px",
    width: "100%"
  },
  dialogTitleContainer: {
    paddingBottom: "1px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  dialogTitle: {
    fontWeight: "bold",
    fontSize: "24px",
    display: "block",
    margin: 0
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 120
  },
  noAdminsMessage: {
    mt: 2,
    fontWeight: 400
  },
  subtitle: {
    mb: 2
  },
  emailLink: {
    textDecoration: "none",
    color: colors.primary,
    fontSize: 14,
    fontWeight: 600
  },
  dialogActions: {
    pr: 3,
    pb: 4
  },
  closeButton: {
    minWidth: 90,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 14
  }
};
